module.exports = __webpack_public_path__ + "img/diamondsAsSaving@2x.017ba72.webp";